
<template>
  <div class="user_info" v-if="userInfo != null">
    {{ $t('layout2.UserSetting.2595811-0') }}
    <a href="/">{{ userInfo.name }}</a
    ><span></span>
    <div class="dmenu">
      <!-- <a href="/personal-center">用户中心</a> -->
      <!-- <a href="/user-center/index">用户资料</a>
      <a href="/home-service-center/changePassword">修改密码</a>
      <a href="/personal-center/index?isNew=true">新建公司</a>
      <a v-if="userInfo.status == '10'" href="javascript:void(0);">申请协同开票</a> -->
      <a href="javascript:void(0);" @click="logout">{{ $t('layout2.UserSetting.2595811-1') }}</a>
      <a
        v-for="(item, index) in supplierArr"
        :key="index"
        :class="index === selectIndex? 'select-div': ''"
        href="javascript:void(0);"
        @click="supplierChange(item, index)"
      >
        {{ item.supplierName? item.supplierName: item.supplierId }}
      </a>
    </div>
  </div>
</template>

<script>
import jsCookie from "js-cookie";
import { mapState } from "vuex";
import { cloneDeep } from 'lodash';
import store from '@/framework/store';
import { getAllSupplier } from "@/api/index";
export default {
  components: {},
  computed: {
    ...mapState({
      userId: (state) => state.user.userId,
      userName: (state) => state.user.userName,
      status: (state) => state.user.status,
    }),
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("user")),
      supplierArr: [],
      selectIndex: -1
    };
  },
  created() {},
  mounted() {
    const isLogin = !!window.localStorage.getItem('user')
    if (isLogin) {
      this.getInfoData()
    }
    this.$eventBus.$on("supplierchange", supplierId => {
      const findIndex = this.supplierArr.findIndex(ele => ele.value === supplierId)
      this.selectIndex = findIndex
    });
  },
  methods: {
    logout() {
      localStorage.removeItem("user");
      localStorage.setItem("sessionEpoch", Date.now());
      jsCookie.remove("Admin-Token");
      localStorage.removeItem("supplierCode")
      localStorage.removeItem("supplierId")
      localStorage.removeItem('supplierCode2')
      this.$router.push("/login");
    },
    goNewCom(){
      this.$router.push({
        path:'/personal-center/index',
        query:{
          isNew:true,
          date:new Date().getTime()
        }

      });
    },
    async getInfoData() {
      const userInfo = localStorage.getItem("user")
      const userObj =  JSON.parse(userInfo?userInfo: '{}')
      let str2 = Number(userObj.id) * 2;
      let str5 = Number(userObj.id) * 5;
      let str10 = Number(userObj.id) * 10;
      let str = `${str2}+${str5}+${str10}+`+(Number(userObj.id)+12345);
      const params = { account:  window.btoa(str) }
      if (this.supplierArr.length) return
      const { code, data} = await getAllSupplier(params)
      if (code === 200) {
        this.supplierArr = data.data.map(ele => {
          ele.value = ele.supplierId
          return ele
        })
        localStorage.setItem("supplierArr", JSON.stringify(this.supplierArr));
        if (this.supplierArr.length) {
          // console.log('UserSettingUserSetting')
          let supplierId = localStorage.getItem('supplierId')
          let index = 0
          if (supplierId) {
            index = this.supplierArr.findIndex(ele => ele.value === supplierId)
            if (index === -1) {
              supplierId = this.supplierArr[0]
              index = 0
            } else {
              supplierId = this.supplierArr[index]
            }
          } else {
            supplierId = this.supplierArr[0]
          }
          // this.supplierChange(supplierId, index)
          localStorage.setItem("supplierId", supplierId.supplierId);
          localStorage.setItem("supplierCode", supplierId.supplierCode);
          localStorage.setItem("supplierSnCode", supplierId.supplierSnCode);
          localStorage.setItem("supplierName", supplierId.supplierName);
        }
      }
    },
    supplierChange(val, index) {
     let isNew = this.$route.query.isNew ? this.$route.query.isNew : false;
     if(isNew) {
      return this.$message.warning('新建公司页面不支持切换供应商，请去基本资料管理页面修改')
     }
      console.log('val===',val);
      this.selectIndex = index
      localStorage.setItem("supplierId", val.supplierId);
      localStorage.setItem("supplierCode", val.supplierCode);
      localStorage.setItem("supplierSnCode", val.supplierSnCode);
      localStorage.setItem("supplierName", val.supplierName);
      this.$eventBus.$emit("hearSupplierchange", val.supplierId, this.supplierArr);
      console.log('User当前用户信息暂存', cloneDeep(val))
      store.dispatch('user/setInfo', {supplierInfo:val})
    }
  },
};
</script>
